const FEISHU_SUPPORT_DESK_GUIDE_PATTERNS = [
  /^\/child\/microapp-handbill\/retail-order\/compile-retail-order-by-customer/,
  /^\/child\/microapp-handbill\/view-order\/create-retail-order-by-customer/,
  /^\/child\/microapp-handbill\/retail-order\/create-retail-order-by-customer/,
  /^\/child\/microapp-handbill\/mtds-order-managment\/big-business-order/,
  /^\/child\/microapp-handbill\/mtds-order-managment\/my-order/,
  /^\/child\/microapp-handbill\/mtds-order-managment\/department-order/,
  /^\/child\/microapp-handbill\/pending-order/,
  /^\/child\/microapp-handbill\/all-pending-order/,
  /^\/child\/microapp-handbill\/project-order\/all-order/,
  /^\/child\/microapp-handbill\/my-shop-order/,
  /^\/child\/microapp-handbill\/subordinates-order/,
  /^\/child\/microapp-handbill\/my-deal-order/,
  /^\/child\/microapp-handbill\/mtds-order-managment\/internal-my-order/,
  /^\/child\/microapp-handbill\/caxaOneStepOrderByCustomer\/checkOrderByCustomer/,
  /^\/child\/microapp-handbill\/retail-order\/carrier-information-management/,
  /^\/child\/microapp-caxaOneClickOrder\/caxaOneStepOrderByCustomer\/mtdsOrCustomerOrder/,
  /^\/child\/microapp-caxaOneClickOrder\/caxaOneStepOrderByCustomer\/mtdsOrCustomerOrder\/edit/,
  /^\/child\/microapp-caxaOneClickOrder\/caxaOneStepOrderByCustomer\/mtdsOrCustomerOrder\/view/,
  /^\/caxaOneStepOrderByCustomer\/retail/,
  /^\/child\/microapp-handbill\/retail-order\/verify-order-information/,
  /^\/child\/microapp-handbill\/create-leave-order/,
  /^\/child\/microapp-handbill\/create-leave-order-customer/,
  /^\/child\/microapp-handbill\/create-simple-serviceNo/,
  /^\/service\/create-serviceNo/,
  /^\/unify-select/
];
function normalizeFeishuSupportDeskPath(urlOrPath) {
  if (!urlOrPath)
    return "";
  try {
    const parsed = new URL(urlOrPath, window.location.origin);
    const hashPath = parsed.hash.startsWith("#") ? parsed.hash.slice(1) : parsed.hash;
    return hashPath || parsed.pathname || "";
  } catch (error) {
    console.warn("Failed to parse URL, falling back to raw string:", error);
    const hashIndex = urlOrPath.indexOf("#");
    return hashIndex >= 0 ? urlOrPath.slice(hashIndex + 1) : urlOrPath;
  }
}
function shouldShowFeishuSupportDeskGuide(urlOrPath = window.location.href) {
  const path = normalizeFeishuSupportDeskPath(urlOrPath);
  return FEISHU_SUPPORT_DESK_GUIDE_PATTERNS.some((pattern) => pattern.test(path));
}
export { shouldShowFeishuSupportDeskGuide };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/feishu/feishuSupportDeskGuide.js